Postlogin = (function (postlogin) {
    postlogin.GroupStudents = {};
    const self = postlogin.GroupStudents;

    self.init = function () {
        initBootstrapTable();
    };

    const $groupStudentListTable = $('#group-student-list-table');
    const groupId = $groupStudentListTable.data('group-id');
    const viewUrl = $groupStudentListTable.data('view-url');
    const hideDisabledUsers = $groupStudentListTable.data('hide-disabled-users') === true;

    const initBootstrapTable = function () {
        $groupStudentListTable.bootstrapTable({
            formatNoMatches() {
                return 'No users to show';
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            sortName: 'date_last_activity',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            search: true,
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/users/list-with-disabled/',
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};
                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;
                queryParams.group_ids = [groupId];
                queryParams.hide_disabled = hideDisabledUsers ? 1 : 0;

                queryParams.active = 1;

                return queryParams;
            },
            columns: [
                {
                    title: 'ID',
                    field: 'user_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return row.disabled ? '-' : value;
                    },
                },
                {
                    title: 'Avatar',
                    field: 'avatar_image_path',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        if (row.disabled) {
                            return `<img src="${value || '/images/avatars/default.png'}" style="width: 50px;"/>`;
                        }

                        const studentViewUrl = viewUrl.replace(':user_id', row.user_id);

                        return `<a href="${studentViewUrl}"><img src="${
                            value || '/images/avatars/default.png'
                        }" style="width: 50px;"/></a>`;
                    },
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        if (row.disabled) {
                            return value;
                        }

                        const studentViewUrl = viewUrl.replace(':user_id', row.user_id);

                        return `<a href="${studentViewUrl}">${value}</a>`;
                    },
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        if (row.disabled) {
                            return value;
                        }

                        const studentViewUrl = viewUrl.replace(':user_id', row.user_id);

                        return `<a href="${studentViewUrl}">${value}</a>`;
                    },
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        if (row.disabled) {
                            return value;
                        }

                        const studentViewUrl = viewUrl.replace(':user_id', row.user_id);

                        return `<a href="${studentViewUrl}">${value}</a>`;
                    },
                },
                {
                    title: 'Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    formatter(value, row) {
                        let convertedDate = Jr.Utils.convertDate(value, 'llll');

                        if (row.uri) {
                            convertedDate += ` on ${row.uri}`;
                        }

                        if (row.logged_in) {
                            convertedDate += ' <i class="fa-regular fa-clock" aria-hidden="true"></i>';
                        }

                        return convertedDate;
                    },
                },
                {
                    title: 'Site Visits',
                    field: 'logins',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Time Spent',
                    field: 'time_on_site',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        if (value > 0) {
                            const duration = moment.duration(value * 1000); // convert seconds to milliseconds

                            return `<span title="${duration.asMinutes()} minutes">${duration.humanize()}</span>`;
                        }
                        return '';
                    },
                },
                {
                    title: 'District',
                    field: 'display_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],

            responseHandler(res) {
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle(row) {
                let classes = '';

                if (row.logged_in) {
                    classes += 'success ';
                }

                if (!row.active) {
                    classes += 'danger ';
                }

                return { classes };
            },
        });
    };

    return postlogin;
}(Postlogin || {}));
